import { getTrueupLedger, getTrueupSummary, updateTrueupReason } from "@hp/api-client";
import type { TrueupLine, TrueupSummary, UpdateTrueupReasonRequest } from "@hp/types";
import { USE_MOCK_DATA } from "./config";
import { simulateNetwork } from "./simulateNetwork";

/** GET /trueup/summary - the "True-up gaps" card. */
export function fetchTrueupSummary(): Promise<TrueupSummary> {
  if (!USE_MOCK_DATA) return getTrueupSummary();
  return simulateNetwork({ orders: 0, material_gaps: 0, total_gap_cr: 0, latest_year: null });
}

/** GET /trueup/ledger - every line of HP's true-up orders. */
export function fetchTrueupLedger(): Promise<TrueupLine[]> {
  if (!USE_MOCK_DATA) return getTrueupLedger();
  return simulateNetwork([]);
}

/** PATCH /trueup/lines/{id}/reason - a reviewer edits or confirms why an item was cut. */
export function saveTrueupReason(id: string, body: UpdateTrueupReasonRequest): Promise<TrueupLine> {
  if (!USE_MOCK_DATA) return updateTrueupReason(id, body);
  return simulateNetwork({} as TrueupLine);
}
